/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_List_Name_PlaceholderInputs */

const en_markers_list_name_placeholder = /** @type {(inputs: Markers_List_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a list name here`)
};

const fr_markers_list_name_placeholder = /** @type {(inputs: Markers_List_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisir un nom de liste`)
};

const de_markers_list_name_placeholder = /** @type {(inputs: Markers_List_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie hier einen Listennamen ein.`)
};

const it_markers_list_name_placeholder = /** @type {(inputs: Markers_List_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci qui un nome per l'elenco`)
};

const ru_markers_list_name_placeholder = /** @type {(inputs: Markers_List_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите название списка здесь`)
};

const es_markers_list_name_placeholder = /** @type {(inputs: Markers_List_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca un nombre de lista aquí`)
};

const zh_cn2_markers_list_name_placeholder = /** @type {(inputs: Markers_List_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在此处输入列表名称`)
};

const ja_markers_list_name_placeholder = /** @type {(inputs: Markers_List_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここにリスト名を入力してください`)
};

const hi_markers_list_name_placeholder = /** @type {(inputs: Markers_List_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यहां सूची का नाम दर्ज करें`)
};

const pt_pt2_markers_list_name_placeholder = /** @type {(inputs: Markers_List_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira aqui o nome da lista`)
};

/**
* | output |
* | --- |
* | "Enter a list name here" |
*
* @param {Markers_List_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_list_name_placeholder = /** @type {((inputs?: Markers_List_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_List_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_list_name_placeholder(inputs)
	if (locale === "de") return de_markers_list_name_placeholder(inputs)
	if (locale === "it") return it_markers_list_name_placeholder(inputs)
	if (locale === "ru") return ru_markers_list_name_placeholder(inputs)
	if (locale === "es") return es_markers_list_name_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_list_name_placeholder(inputs)
	if (locale === "ja") return ja_markers_list_name_placeholder(inputs)
	if (locale === "hi") return hi_markers_list_name_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_list_name_placeholder(inputs)
	return en_markers_list_name_placeholder(inputs)
});